// extracted by mini-css-extract-plugin
export default {"label":"TextInputField_label__eeyC7","required":"TextInputField_required__fhiO5","input":"TextInputField_input__GNnQO"};